import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "wc-configured-product-section-rows" }


import { useI18n } from 'vue-i18n';
import WCProductRowModern from '@/components/WCProductRow/WCProductRowModern.vue';

interface ConfiguredRow {
  id: string;
  name: string;
}

interface Props {
  name: string;
  rows?: ConfiguredRow[];
  hideCoupons?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WCConfiguredProductSectionRows',
  props: {
    name: {},
    rows: { default: () => [] },
    hideCoupons: { type: Boolean, default: false }
  },
  setup(__props: any) {



const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  const _component_WCCouponRowModern = _resolveComponent("WCCouponRowModern")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", {
      ref: "focusFirst",
      class: "sr-only"
    }, _toDisplayString(_ctx.name) + " " + _toDisplayString(_unref(t)('homePage')), 513),
    _cache[0] || (_cache[0] = _createTextVNode()),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
      return (_openBlock(), _createBlock(WCProductRowModern, {
        key: row.id,
        rowId: row.id,
        rowName: row.name
      }, null, 8, ["rowId", "rowName"]))
    }), 128)),
    _cache[1] || (_cache[1] = _createTextVNode()),
    (_ctx.$configuration.allowCouponClipping && !_ctx.hideCoupons)
      ? (_openBlock(), _createBlock(_component_WCCouponRowModern, {
          class: "my-md-3",
          key: 'coupon:homepage'
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})